module.exports = __webpack_public_path__ + "static/media/Decision and Order - Patten Homes.6f7817cc.pdf";